import { Button } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";

import { IBaseProps } from "lib/data/interfaces";
import { DataFieldTemplate, MetadataTemplate, SectionTemplate } from "lib/data/model";

import { DataTemplateSelector } from "../../components/";


interface IMetaDataProps extends IBaseProps {
	sectionTemplate: SectionTemplate;
	waitingForUpdate: boolean;
	toggleEditing: () => void;
	hardSectionTemplateUpdate: (callback?: () => void) => void;
	softSectionTemplateUpdate: () => void;
}

interface IMetaDataState {
	dataTemplateOptions: DataFieldTemplate[];
}

export class MetaData extends React.Component<IMetaDataProps, IMetaDataState> {

	constructor(props: IMetaDataProps) {
		super(props);
		this.state = {
			dataTemplateOptions: []
		};
	}

	public render = () => {
		// the section has a metadata template
		if (this.props.sectionTemplate.dataTemplate) {
			// requirements list exsists on metadataTemplate
			if (this.props.sectionTemplate.dataTemplate.requirements) {
				return (
					<div>
						<Title level={3}>Section Header Template</Title>
						{/* you are currently editing the section header */}
						<div className="metadata-wrapper">
							<Button type="primary" icon="left" onClick={this.props.toggleEditing} >Back</Button>
							<DataTemplateSelector
								waitingForUpdate={this.props.waitingForUpdate}
								hardSectionTemplateUpdate={this.props.hardSectionTemplateUpdate}
								softSectionTemplateUpdate={this.props.softSectionTemplateUpdate}
								metadataTemplate={this.props.sectionTemplate.dataTemplate}
							/>
						</div>
					</div>
				);
			}
			// there is a metadataTemplate but it has no requirements list
			else {
				return null;
			}
		}
		else {
			return (
				<div>
					<Title level={3}>Section Header Template</Title>
					<Button type="primary" icon="left" onClick={this.props.toggleEditing} >Back</Button>
					<br />
					<Button type="primary" icon="plus" onClick={this.addSectionTemplateHeader}>Add Section Header Template</Button>
				</div>
			);
		}
	}

	private addSectionTemplateHeader = () => {
		const metadataTemplate = new MetadataTemplate();
		this.props.sectionTemplate.dataTemplate = metadataTemplate;
		this.props.softSectionTemplateUpdate();
	}
}
